import { CheckboxComponent } from './checkbox.component';

export const Checkbox = CheckboxComponent;
